import BeneficiosCondicionesItem from "./beneficiosCondicionesItem";

class BeneficiosCondiciones extends React.Component {
  constructor() {
    super();

    this.state = {
      beneficiosItems: "",
      beneficiosItemsPlanVital: "",
    };

    this.scrollTo = this.scrollTo.bind(this);
    this.pnpService = new ServicioPnp();
  }

  resetItemsTitle(e) {
    console.log(e);
  }

  parseResponse(data, isPlanVital) {
    if (!isPlanVital) {
      this.setState({
        beneficiosItems: data.map((item) => (
          <BeneficiosCondicionesItem
            item={item}
            resetItemsTitle={(e) => this.resetItemsTitle(e)}
          />
        )),
      });
    } else {
      this.setState({
        beneficiosItemsPlanVital: data.map((item) => (
          // reemplaza palabra clave {currentYear} seteada en lista de sharepoint por el año actual
          <BeneficiosCondicionesItem
            item={{
              ...item,
              CSDescripcionRichTextNote: item.CSDescripcionRichTextNote.replace(
                "&#123;currentYear&#125;",
                `${new Date().getFullYear()}`
              ),
            }}
            resetItemsTitle={(e) => this.resetItemsTitle(e)}
          />
        )),
      });
    }
  }

  componentDidMount() {
    this.pnpService.getList(
      "beneficiosCondiciones",
      (data) => this.parseResponse(data),
      "CSVisibleBool eq 1",
      "CSTituloSeccionText",
      "CSTituloText",
      "CSDescripcionRichTextNote",
      "CSImagenIconoText"
    );
    this.pnpService.getList(
      "beneficiosCondiciones",
      (data) => this.parseResponse(data, true),
      "Plan_x0020_Vital eq 1",
      "CSTituloSeccionText",
      "CSTituloText",
      "CSDescripcionRichTextNote",
      "CSImagenIconoText"
    );
  }

  scrollTo(elementId, event) {
    event.preventDefault();
    let windowWidth = $(window).width();
    $("html, body").animate(
      {
        scrollTop: $(elementId).offset().top - $("header").height() + 60,
      },
      "fast"
    );
  }

  render() {
    return (
      <div>
        <div className="beneficios row-bottom" id="beneficios">
          <br />
          <br />
          <h2 className="cotizar-intro">
            Beneficios y Condiciones Del Plan Complementario Especial
          </h2>
          <PanelGroup id="accordion-example">
            {this.state.beneficiosItems}
          </PanelGroup>
          <br />
          <br />
          <h2 className="cotizar-intro">
            Beneficios y Condiciones Del Plan Vital
          </h2>
          <PanelGroup id="accordion-example">
            {this.state.beneficiosItemsPlanVital}
          </PanelGroup>

          <div className="text-center">
            {this.props.configurations["CotizaPlanComplementarioIcono"] && (
              <a
                href="#cotizar"
                onClick={(event) => this.scrollTo("#cotizar", event)}
              >
                <img
                  src={
                    _spPageContextInfo.siteAbsoluteUrl +
                    "/Style Library/Images/" +
                    this.props.configurations["CotizaPlanComplementarioIcono"]
                  }
                />
              </a>
            )}
            <p className="beneficios-note">
              {this.props.configurations["CotizaPlanComplementario"]}
            </p>
          </div>
        </div>
      </div>
    );
  }
}

/******************** BUILD ********************/
const Accordion = ReactBootstrap.Accordion;
const Panel = ReactBootstrap.Panel;
const PanelGroup = ReactBootstrap.PanelGroup;
/******************** BUILD ********************/

export default BeneficiosCondiciones;
